import {
    TimelineConnector,
    TimelineContent,
    TimelineDot,
    TimelineItem, timelineItemClasses,
    TimelineOppositeContent,
    TimelineSeparator
} from "@mui/lab";
import Timeline from "@mui/lab/Timeline";
import "./timeline.scss"
import {colorsChip, education_data, experience_data} from "../../data/data";
import {faLocationDot} from "@fortawesome/free-solid-svg-icons";
import * as React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Chip, createStyles, IconButton, LinearProgress, styled} from "@mui/material";
import { IconCalendarCode } from '@tabler/icons-react';

function getColorFromColorsChip(index) {
    return colorsChip[colorsChip.length-index-1];
}

export function TimeLine({isEducationSelected}){
    const [isMobile, setIsMobile] = React.useState(false);

    React.useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setIsMobile(true);
            } else {
                setIsMobile(false);
            }
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className={"timeline"}>
            {!isMobile ? <Timeline position="alternate" className={"timeline"}>
                    {(isEducationSelected ? education_data : experience_data).map((data, index) => {
                        return (
                            <TimelineItem>
                                <TimelineOppositeContent
                                    sx={{ m: 'auto 0' }}
                                    align="right"
                                    variant="body2">
                                    <div className={index%2 === 0 ? 'item-date' : 'item-date-reverse'}>
                                        <div className={"title"}>
                                            <IconCalendarCode size={25} />
                                            <h3 className={"title-date"}>{data.date}</h3>
                                        </div>
                                        <div className={"content-chip"}>
                                            {data.tags.map((tag, item) => (
                                                <Chip label={tag ?? ''} className={"chip"} style={{backgroundColor: getColorFromColorsChip(item)}} />
                                            ))}
                                        </div>
                                    </div>
                                </TimelineOppositeContent>
                                <TimelineSeparator>
                                    <TimelineConnector />
                                    <TimelineDot sx={{ bgcolor: '#4c02f1'}}>
                                        {data.icon}
                                    </TimelineDot>
                                    <TimelineConnector />
                                </TimelineSeparator>
                                <TimelineContent sx={{ py: '12px', px: 2 }}>
                                    <div className={index%2 === 0 ? 'content-experience' : 'content-experience-reverse'}>
                                        {!isEducationSelected && data?.logo && index%2 === 0 ? <div className={"content-image-project"} id={data.idImage}>
                                            <img src={data.logo} alt={data.title} className={"image"}/>
                                        </div> : ""}
                                        <div className={"timeline-element"}>
                                            <h3 className={"title"}>{data.title}</h3>
                                            <div className={index%2 === 0 ? 'subtitle-content' : 'subtitle-content-reverse'}>
                                                <span className={"subtitle"}>{data.description}</span>
                                                <div style={{display:'flex', gap: 20}}>
                                                    <p className={"location"}><FontAwesomeIcon icon={faLocationDot} className={"icon"}/>{data.location}</p>
                                                    {data.buttonIcon?.icon ? <a style={{color:'white'}} href={data.buttonIcon.link} className={"link"}>{data.buttonIcon.icon} {data.buttonIcon.linkName}</a> : null}
                                                </div>
                                            </div>
                                        </div>
                                        {!isEducationSelected && data?.logo && index%2 !== 0 ? <div className={"content-image-project"} id={data.idImage}>
                                            <img src={data.logo} alt={data.title} className={"image"} />
                                        </div> : ""}
                                    </div>
                                </TimelineContent>
                            </TimelineItem>
                        )
                    })
                    }
                </Timeline> :
                <Timeline position="right" className={"timeline"} sx={{
                    [`& .${timelineItemClasses.root}:before`]: {
                        flex: 0,
                        padding: 0,
                    },
                }}>
                    {(isEducationSelected ? education_data : experience_data).map((data, index) => {
                        return (
                            <TimelineItem>
                                <TimelineSeparator>
                                    <TimelineConnector />
                                    <TimelineDot sx={{ bgcolor: '#4c02f1'}}>
                                        {data.icon}
                                    </TimelineDot>
                                    <TimelineConnector />
                                </TimelineSeparator>
                                <TimelineContent sx={{ py: '12px', px: 2 }}>
                                    <div className={'item-date-reverse'}>
                                        <div className={"title"}>
                                            <IconCalendarCode size={25} />
                                            <h3 className={"title-date"}>{data.date}</h3>
                                        </div>
                                        <div className={"content-chip"}>
                                            {data.tags.map((tag, item) => (
                                                <Chip label={tag ?? ''} className={"chip"} style={{backgroundColor: getColorFromColorsChip(item)}} />
                                            ))}
                                        </div>
                                    </div>
                                    <h3 className={"title"}>{data.title}</h3>
                                    <div className={'subtitle-content-reverse'}>
                                        <span className={"subtitle"}>{data.description}</span>
                                        <div style={{display:'flex', gap: 20}}>
                                            <p className={"location"}><FontAwesomeIcon icon={faLocationDot} className={"icon"}/>{data.location}</p>
                                            {!isEducationSelected && data.buttonIcon?.icon ? <a style={{color:'white'}} href={data.buttonIcon.link} className={"link"}>{data.buttonIcon.icon} {data.buttonIcon.linkName}</a> : null}
                                        </div>
                                    </div>
                                </TimelineContent>
                            </TimelineItem>
                        )
                    })
                    }
                </Timeline>
            }
        </div>);
}

